import { render } from "./BootstrapTextArea.vue?vue&type=template&id=983ba946"
import script from "./BootstrapTextArea.vue?vue&type=script&lang=js"
export * from "./BootstrapTextArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__